import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.xl};
`;

const Section = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const Subtitle = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  margin: ${({ theme }) => `${theme.spacing.lg} 0`};
  font-size: 1.5rem;
`;

const Text = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  line-height: 1.6;
`;

const Terms = () => {
  return (
    <Container>
      <Title>Terms of Service</Title>
      
      <Section>
        <Text>Last updated: January 2024</Text>
        <Text>
          Please read these Terms of Service carefully before using Binventory. By using our service, 
          you agree to be bound by these terms.
        </Text>
      </Section>

      <Section>
        <Subtitle>1. Service Description</Subtitle>
        <Text>
          Binventory is a home inventory management system that allows users to organize, track, 
          and manage their belongings. We provide both free and premium subscription services.
        </Text>
      </Section>

      <Section>
        <Subtitle>2. User Accounts</Subtitle>
        <Text>
          You must create an account to use Binventory. You are responsible for maintaining the 
          security of your account and for all activities that occur under your account.
        </Text>
      </Section>

      <Section>
        <Subtitle>3. Subscription and Payments</Subtitle>
        <Text>
          Premium features require a paid subscription. All payments are processed securely through 
          Stripe. Subscriptions automatically renew unless cancelled before the renewal date.
        </Text>
        <Text>
          Refunds are handled according to our Refund Policy. Subscription cancellations take effect 
          at the end of the current billing period.
        </Text>
      </Section>

      <Section>
        <Subtitle>4. Data Privacy</Subtitle>
        <Text>
          We take your privacy seriously. Our Privacy Policy details how we collect, use, and protect 
          your personal information and inventory data.
        </Text>
      </Section>

      <Section>
        <Subtitle>5. Acceptable Use</Subtitle>
        <Text>
          You agree not to misuse the Binventory service or help anyone else do so. This includes 
          attempting to gain unauthorized access, transmitting malware, or engaging in abusive behavior.
        </Text>
      </Section>

      <Section>
        <Subtitle>6. Contact Information</Subtitle>
        <Text>
          For questions about these terms, please contact us at:
        </Text>
        <Text>
          Email: legal@binventory.com<br />
          Phone: (555) 123-4567<br />
          Address: 123 Inventory Lane, Suite 100, San Francisco, CA 94105
        </Text>
      </Section>
    </Container>
  );
};

export default Terms; 